import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { StatusLookup, UserRoleLookup } from '../models/lookup.model';
import { normalizeApiArray } from '../utils/api-response.util';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private apiUrl = `${environment.apiUrl}/lookups`;

  constructor(private http: HttpClient) {}

  getStatuses(): Observable<StatusLookup[]> {
    return this.http.get<unknown>(`${this.apiUrl}/statuses`).pipe(
      map(response => normalizeApiArray<any>(response).map(item => ({
        statusID: Number(item.statusID ?? item.StatusID ?? item.statusId ?? item.id ?? item.ID),
        statusName: String(item.statusName ?? item.StatusName ?? item.name ?? item.Name ?? item.status ?? item.Status ?? ''),
        statusDescription: item.statusDescription ?? item.StatusDescription ?? item.description ?? item.Description ?? null
      })).filter(status => Number.isFinite(status.statusID)))
    );
  }

  getUserRoles(): Observable<UserRoleLookup[]> {
    return this.http.get<unknown>(`${this.apiUrl}/user-roles`).pipe(
      map(response => normalizeApiArray<any>(response).map(item => ({
        userRoleID: Number(item.userRoleID ?? item.UserRoleID ?? item.userRoleId ?? item.id ?? item.ID),
        userRoleName: String(item.userRoleName ?? item.UserRoleName ?? item.name ?? item.Name ?? item.role ?? item.Role ?? ''),
        userRoleDescription: item.userRoleDescription ?? item.UserRoleDescription ?? item.description ?? item.Description ?? null
      })).filter(role => Number.isFinite(role.userRoleID)))
    );
  }
}
